import React from "react";
import { CirclePlus } from "lucide-react";
import { Link } from "react-router-dom";
import CategoriesListView from "./components/CategoriesListView";

export default function CategoriesPage() {
  return (
    <main className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="fw-bold h4">Categories</h1>
        <Link to="/admin/categories/form">
          <button className="btn btn-primary d-flex align-items-center gap-2 shadow">
            <CirclePlus />
            Add Category
          </button>
        </Link>
      </div>
      <CategoriesListView />
    </main>
  );
}
